import React, {useState} from 'react';
import {Tag, Upload} from 'antd';
import mammoth from 'mammoth';
import {IoAttachOutline} from 'react-icons/io5';
import {ERROR_MESSAGES, FILE_CONSTANTS} from '@/constants/messages';
import {handleError} from '@/utils/helpers';
import textUpload from "@/pages/Index/static/textUpload.png";

const { Dragger } = Upload;

// @ts-ignore
const DocxParser = ({ fList, fileChange,setData }) => {
    const [parsedContent, setParsedContent] = useState<Record<string, string>>({  });

    const handleFileRead = async (file: Blob,  name:string) => {
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          // @ts-ignore
          const arrayBuffer = e.target.result;

          // 使用 mammoth 解析 docx 内容
          // @ts-ignore
          const result = await mammoth.convertToHtml({ arrayBuffer });
          // setParsedContent(result.value);
          parsedContent[name] = result.value;
          setData(parsedContent);
          // 也可以提取纯文本：
          // const result = await mammoth.extractRawText({ arrayBuffer });
          // setParsedContent(result.value);
        };
        reader.readAsArrayBuffer(file);
      } catch (error) {
        handleError(error, ERROR_MESSAGES.FILE_PARSE_ERROR);
      }
    };

    return (
      // <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <div>
        <Upload
          // showUploadList={false}
          name="file"
          // multiple={false}
          accept={FILE_CONSTANTS.ACCEPTED_DOC_FORMATS}
          beforeUpload={(file) => {
            handleFileRead(file, file.name);
            return false; // 阻止自动上传
          }}
          customRequest={() => {
          }} // 覆盖默认上传行为
          onRemove={false}

          showUploadList={false}
          iconRender={()=><Tag color="cyan-inverse">文本</Tag>}
          maxCount={FILE_CONSTANTS.MAX_UPLOAD_COUNT}
          onChange={info => {
            console.log("txt file change",info);
            fileChange(info);
          }}
          fileList={fList}
        >
          <img
            src={textUpload}
            className="w-5 h-5
            object-contain font-thin transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-110 hover:cursor-pointer
            "
            style={{ opacity: 0.8 }}
          />
        </Upload>
      </div>
    );
  }
;

export default DocxParser;